export default __webpack_public_path__ + "static/media/imgabonar.a4b3287f.png";